export const MAX_REPAY_RATIO = '1.0011';
export const MAX_COIN_RATIO = '0.999';
